// extracted by mini-css-extract-plugin
export default {"phoneInput":"Phone_phoneInput__dgTuj"};